import { FC, ReactElement } from 'react';
import i18next from 'i18next';
import { ExerciseDto } from '../../../../../../shared/dtos/exercise.dto';
import ExercisePickerChip from './ExercisePickerChip';

type ExercisePickerSelectionBarProps = {
  selectedExercises: ExerciseDto[];
  onRemove: (exercise: ExerciseDto) => void;
};

const ExercisePickerSelectionBar: FC<ExercisePickerSelectionBarProps> = ({
  selectedExercises,
  onRemove,
}: ExercisePickerSelectionBarProps): ReactElement | null => {
  if (selectedExercises.length === 0) {
    return null;
  }

  const userLanguage: string = i18next.language;

  return (
    <div className="bg-white border-top pt-3 mt-3">
      <div className="d-flex align-items-center gap-2 overflow-x-auto flex-nowrap pb-2">
        <span className="text-muted small flex-shrink-0">
          {i18next.t('exerciseModal.selectedCount', { count: selectedExercises.length })}
        </span>

        {selectedExercises.map((exercise: ExerciseDto) => (
          <ExercisePickerChip
            key={`selected-${exercise.id}`}
            label={userLanguage === 'en' ? exercise.enName : exercise.deName}
            removeLabel={i18next.t('exerciseModal.removeSelection')}
            onRemove={() => onRemove(exercise)}
          />
        ))}
      </div>
    </div>
  );
};

export default ExercisePickerSelectionBar;
